// VFM live fixes: gallery aspect-fit + product title/CTA rewriter + qspec box override
(function(){
  var CONTAINER_RATIO = 4 / 3;
  var TOLERANCE = 0.25;
  function applyFit(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    var r = img.naturalWidth / img.naturalHeight;
    var delta = Math.abs(r - CONTAINER_RATIO) / CONTAINER_RATIO;
    if (delta > TOLERANCE) img.classList.add('dv2-fit-contain');
    else img.classList.remove('dv2-fit-contain');
  }
  function scanGallery() {
    document.querySelectorAll('.dv2-gallery-main img').forEach(function(img){
      if (img.complete) applyFit(img);
      else img.addEventListener('load', function(){ applyFit(img); }, {once:true});
    });
  }

  function currentHandle() {
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Get the canonical product name from our qspec DB data (not document.title which
  // can be an outdated SEO title metafield with wrong casing).
  function getProductName() {
    var handle = currentHandle();
    if (window.VFM_QSPEC && handle && window.VFM_QSPEC[handle]) {
      return window.VFM_QSPEC[handle].name;
    }
    // Fallback: parse document.title
    var t = (document.title || '').replace(/\s*[-\u2013\u2014|]\s*The Vansmith.*$/i, '').trim();
    return t || null;
  }

  function rewriteTitles() {
    var name = getProductName();
    if (!name) return;
    document.querySelectorAll('.dv2-title, h1.dv2-title').forEach(function(el){
      if (el.textContent.trim() !== name) el.textContent = name;
    });
    var rx = /^Customize your .+? now$/i;
    document.querySelectorAll('a, button').forEach(function(el){
      var tx = el.textContent.trim();
      if (rx.test(tx)) {
        var newText = 'Customize your ' + name + ' now';
        if (tx !== newText) el.textContent = newText;
      }
    });
    // Also fix the page title tag
    var expectedTitle = name + ' - The Vansmith';
    if (document.title !== expectedTitle) document.title = expectedTitle;
  }

  function rewriteQspecs() {
    if (!window.VFM_QSPEC) return;
    var handle = currentHandle();
    if (!handle) return;
    var q = window.VFM_QSPEC[handle];
    if (!q) return;
    var pairs = [
      { lbl: 'Length',            val: q.length },
      { lbl: 'Seats / Sleeps',    val: q.seats && q.sleeps
                                         ? (q.seats === q.sleeps ? q.sleeps : q.seats + ' / ' + q.sleeps)
                                         : (q.sleeps || q.seats || '') },
      { lbl: 'Build time',        val: q.build },
      { lbl: 'Drive',             val: q.drive },
    ];
    var boxes = document.querySelectorAll('.dv2-qspecs .dv2-qspec');
    for (var i = 0; i < boxes.length && i < pairs.length; i++) {
      var p = pairs[i];
      if (!p.val) continue;
      var vEl = boxes[i].querySelector('.dv2-qspec-val');
      var lEl = boxes[i].querySelector('.dv2-qspec-lbl');
      if (vEl) vEl.textContent = p.val;
      if (lEl) lEl.textContent = p.lbl;
    }
  }

  function runAll() { scanGallery(); rewriteTitles(); rewriteQspecs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runAll);
  else runAll();
  setTimeout(runAll, 800);
  setTimeout(runAll, 2000);
})();
